/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AdVehicleStreamAdVehicleDoorStatusFragment = {
  __typename?: 'Vehicle'
  id: string
  latestADTelemetry: {
    __typename?: 'ADTelemetry'
    rightSlidingDoorOpen: {
      __typename?: 'ADTelemetryBooleanWithTimestamp'
      value: boolean
      timestamp: string
    } | null
  } | null
}

export type AdVehicleStreamSendDoorRequestMutationVariables = Types.Exact<{
  vehicleId: Types.Scalars['ID']['input']
  desiredDoorStatus: Types.FccTargetDoorStatus
}>

export type AdVehicleStreamSendDoorRequestMutation = {
  __typename?: 'Mutation'
  fccSendDoorRequest: any | null
}

export const AdVehicleStreamAdVehicleDoorStatusFragmentDoc = gql`
    fragment AdVehicleStreamAdVehicleDoorStatus on Vehicle {
  id
  latestADTelemetry {
    rightSlidingDoorOpen {
      value
      timestamp
    }
  }
}
    `
export const AdVehicleStreamSendDoorRequestDocument = gql`
    mutation AdVehicleStreamSendDoorRequest($vehicleId: ID!, $desiredDoorStatus: FccTargetDoorStatus!) {
  fccSendDoorRequest(
    input: {vehicleId: $vehicleId, doorStatus: $desiredDoorStatus}
  )
}
    `
export type AdVehicleStreamSendDoorRequestMutationFn = Apollo.MutationFunction<
  AdVehicleStreamSendDoorRequestMutation,
  AdVehicleStreamSendDoorRequestMutationVariables
>

/**
 * __useAdVehicleStreamSendDoorRequestMutation__
 *
 * To run a mutation, you first call `useAdVehicleStreamSendDoorRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdVehicleStreamSendDoorRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adVehicleStreamSendDoorRequestMutation, { data, loading, error }] = useAdVehicleStreamSendDoorRequestMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      desiredDoorStatus: // value for 'desiredDoorStatus'
 *   },
 * });
 */
export function useAdVehicleStreamSendDoorRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdVehicleStreamSendDoorRequestMutation,
    AdVehicleStreamSendDoorRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AdVehicleStreamSendDoorRequestMutation,
    AdVehicleStreamSendDoorRequestMutationVariables
  >(AdVehicleStreamSendDoorRequestDocument, options)
}
export type AdVehicleStreamSendDoorRequestMutationHookResult = ReturnType<
  typeof useAdVehicleStreamSendDoorRequestMutation
>
export type AdVehicleStreamSendDoorRequestMutationResult =
  Apollo.MutationResult<AdVehicleStreamSendDoorRequestMutation>
export type AdVehicleStreamSendDoorRequestMutationOptions =
  Apollo.BaseMutationOptions<
    AdVehicleStreamSendDoorRequestMutation,
    AdVehicleStreamSendDoorRequestMutationVariables
  >
